import { Survey, SurveyQuery } from '@dreryk/egabinet-survey-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

type PreInterviewUpdateFormLoaderRenderProps = {
   preInterview: Survey;
};

type PreInterviewUpdateFormLoaderProps = {
   readonly surveyId: number | undefined;
   readonly children: (renderProps: PreInterviewUpdateFormLoaderRenderProps) => JSX.Element;
};

export const PreInterviewUpdateFormLoader = (props: PreInterviewUpdateFormLoaderProps): JSX.Element => {
   const { data: preInterview, loading: preInterviewLoading, error: preInterviewError } = useCqrsGet<Survey>(() => {
      const query = new SurveyQuery();
      query.id = props.surveyId!;
      return query;
   });

   if (preInterviewLoading) {
      return <LoaderSpinner />;
   }

   if (preInterviewError) {
      return (
         <Message
            testId={'preInterviewFetchError'}
            type={MessageType.NEGATIVE}
            label={appointmentsTranslationKeys.preInterview.failedToFetch}
            displayIndicator
         />
      );
   }

   return props.children({
      preInterview: preInterview,
   });
};
